import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';

export const useLogClickBenefits = (screenName: string) => {
  return useCallback(() => {
    bridge.logAnalyticsEvent({
      channel: ['firebase', 'facebook', 'amplitude', 'ablylog'],
      name: 'CLICK_BENEFITS',
      analytics: {
        SCREEN: screenName,
      },
    });
  }, [screenName]);
};
